import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 35091AEB-2AF7-4F92-A249-2955F01404A3
 * name monitor
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/monitor.svg
 * tags
 * - Device / Tech 
 */
export const MonitorIcon = createSvgIcon(<><path d="M21,16H3V4H21M21,2H3C1.89,2 1,2.89 1,4V16A2,2 0 0,0 3,18H10V20H8V22H16V20H14V18H21A2,2 0 0,0 23,16V4C23,2.89 22.1,2 21,2Z" /></>, 'MonitorIcon');
export default MonitorIcon